import {liteClient} from 'algoliasearch/lite';
import React, { useState, useEffect, useMemo } from 'react';
import {
  InstantSearch,
  Hits,
  SearchBox,
  Pagination,
  useSearchBox
} from 'react-instantsearch';

import SearchResult from './Components/SearchResult';

// Algolia search client
const searchClient = liteClient(
  'ZQCVH5APSU',
  '30598fe6073d4b8c4cd6a2c93c31a6f2'
);

// Get Algolia index name based on hostname
const getIndexName = (): string => {
  return 'prod_intranet';
};

// Tracks the actual search query from InstantSearch's internal state
// Needed because SearchBox updates InstantSearch's state directly without
// triggering onSearchStateChange during typing
const SearchQueryTracker = ({ onQueryChange }: { onQueryChange: (query: string) => void }) => {
  const { query } = useSearchBox();

  useEffect(() => {
    onQueryChange(query);
  }, [query]);

  return null;
};

const Search = () => {
  const indexName = useMemo(() => getIndexName(), []);
  // Track the actual query from InstantSearch (updates as user types)
  const [currentQuery, setCurrentQuery] = useState('');

  // Show results only when there's a non-empty query
  const hasQuery = Boolean(currentQuery?.trim());

  return (
    <div className="intranet-search">
      <InstantSearch
        indexName={indexName}
        searchClient={searchClient}
        searchState={{ currentQuery }}
      >
        <div className="intranet-search__hero">
          <div className="intranet-search__box">
            <SearchBox
              translations={{
                placeholder: 'Typ hier je zoekterm...',
              }}
              submit={<img src="" alt="" />}
            />
            <SearchQueryTracker onQueryChange={setCurrentQuery} />
          </div>
        </div>

        {hasQuery && (
          <div className="ais-InstantSearch intranet-search__results-wrapper">
            <Hits hitComponent={SearchResult} />
            <Pagination />
          </div>
        )}
      </InstantSearch>
    </div>
  );
}

export default Search;
